import { FC } from "react";
import { DialogData } from "../../types";
import { Icon } from "../../parts/Icon";
import { _ } from "../../utils/helpers";
import { useApp } from "../../context/useApp";
import { DEFAULT_DIALOG_HANDLE, rumba, VENUE_WHATSAPP_NUMBERS } from "../../utils/symbols";

interface ErrorDialogProps {
    dialogData: DialogData
}

export const ErrorDialog: FC<ErrorDialogProps> = ({dialogData}) => {

    const {
        state: { dialogHandles }
    } = useApp()

    if (dialogData.dialog !== 'error') return null
    const mail = rumba.venueId === 1 ? 'reservas@cardamomo.com' : 'reservas@tablaoflamenco1911.com'

    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    return (
        <section 
            className={`df fd-c jcfs aic r3 section p-r py-10 px-10`}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <Icon icon={dialogData.icon ?? 'info'} style={{scale: '1.7'}}/>
            {dialogData.title && (<h2 id="dialog-title" className="text s20-600 center mt-9" aria-hidden>{dialogData.title}</h2>)}
            <p id="dialog-description" className="text s20-400 mb-8 mt-9 center">{dialogData.message}</p>
            <div className="df aic jcsb w-100 fd-c dialog-error-buttons">
            {dialogData.contactUs && (
                <a 
                    target="_blank"
                    className="button px-10 py-7 r3 text  center s20-500 w-100 b-0 contact-us df aic jcc" 
                    href={`https://wa.me/${VENUE_WHATSAPP_NUMBERS[rumba.venueId]}/?text=Hola%20necesito%20ayuda%20sobre%20mi%20reserva`}
                >
                    <Icon icon={'whatsapp'} className="mr-5" style={{scale: '1.2'}}/>
                    {_('1da_write__')}
                </a>
            )}
            {dialogData.contactUsByEmail && (
                <a  
                    target="_blank"
                    href={`mailto:${mail}`}
                    className="button px-10 py-7 r3 text  center s20-500 w-100 b-0 black df aic jcc" 
                >
                    <Icon icon={'support'} className="mr-5" style={{scale: '1.2'}}/>
                    {_('1da_write_e')}
                </a>
            )}
            {!!dialogData.button && (
                <button 
                    className="button black px-10 py-7 r3 text white center s20-500 b-0 w-100" 
                    onClick={() => {
                        (dialogData.callback ?? (() => {}))()
                        // deleteItem('booking-data')
                        // window.location.reload()
                    }}
                >
                    {dialogData.button}
                </button>
            )}
            </div>
            { dialogData.closeButton && (
                <button 
                    className="button b-0 p-2 p-a zi-6 close df aic jcc"
                    onClick={() => dialogHandle.closeDialog()}
                    aria-label={_('0ar_close__')}
                >
                    <Icon icon="close" aria-hidden/>
                </button>
            )}
        </section>
    )
}